import React from 'react';
import { Card, CardActionArea, CardContent, Typography, Box } from '@mui/material';
import { formatEuro, formatPct } from '../../../functions/formatNumber.js';

const ActiuCardGlobal = ({ asset, isSelected, onClick }) => {
  const gp = asset.guanyPerdua || 0;
  const isPositive = gp >= 0;
  const colorGP = isPositive ? '#4CAF50' : '#EF4444';
  const bgBadge = isPositive ? 'rgba(76, 175, 80, 0.12)' : 'rgba(239, 68, 68, 0.12)';
  const borderBadge = isPositive ? '#A5D6A7' : '#FFCDD2';
  const retVal = asset.percentatgeRetorn !== undefined && asset.percentatgeRetorn !== null
    ? asset.percentatgeRetorn
    : 0;
  const tirVal = asset.percentatgeRetornAnualitzat !== undefined && asset.percentatgeRetornAnualitzat !== null
    ? asset.percentatgeRetornAnualitzat
    : null;
  const tirColor = tirVal !== null ? (tirVal >= 0 ? '#2E7D32' : '#D32F2F') : 'text.secondary';

  return (
    <Card
      elevation={isSelected ? 3 : 1}
      sx={{
        borderRadius: '12px',
        border: isSelected ? '2px solid #3F51B5' : '1px solid #E0E0E0',
        backgroundColor: isSelected ? 'rgba(63, 81, 181, 0.04)' : '#FFFFFF',
        transition: 'all 0.2s ease-in-out',
      }}
    >
      <CardActionArea onClick={onClick}>
        <CardContent sx={{ p: '12px !important' }}>
          {/* Capçalera */}
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 0.5 }}>
            <Box sx={{ pr: 1 }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold', lineHeight: 1.2 }}>
                {asset.nom}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {asset.quantitat} ut · {formatEuro(asset.darrerPreu)}/ut
              </Typography>
            </Box>
            <Box
              sx={{
                backgroundColor: bgBadge,
                color: colorGP,
                border: `1px solid ${borderBadge}`,
                borderRadius: '12px',
                px: 1,
                py: 0.2,
                fontSize: '0.8rem',
                fontWeight: 'bold',
                whiteSpace: 'nowrap',
              }}
            >
              {retVal >= 0 ? '+' : ''}{formatPct(retVal)}
            </Box>
          </Box>

          {/* Bloc de mètriques */}
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: 1,
              mt: 1.2,
              pt: 1,
              borderTop: '1px dashed #EEEEEE',
            }}
          >
            <Box>
              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', fontSize: '0.7rem' }}>
                VALOR ACTUAL
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: 'bold', color: '#3F51B5' }}>
                {formatEuro(asset.valorActual)}
              </Typography>
            </Box>
            <Box sx={{ textAlign: 'right' }}>
              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', fontSize: '0.7rem' }}>
                GUANY / PÈRDUA
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: 'bold', color: colorGP }}>
                {isPositive ? '+' : ''}{formatEuro(gp)}
              </Typography>
            </Box>
            <Box>
              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', fontSize: '0.7rem' }}>
                TOTAL INVERTIT
              </Typography>
              <Typography variant="body2" sx={{ color: '#666666' }}>
                {formatEuro(asset.totalInvertit)}
              </Typography>
            </Box>
            <Box sx={{ textAlign: 'right' }}>
              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', fontSize: '0.7rem' }}>
                TIR (A.A.)
              </Typography>
              <Typography variant="body2" sx={{ fontWeight: 'bold', color: tirColor }}>
                {tirVal !== null ? `${tirVal >= 0 ? '+' : ''}${formatPct(tirVal)} a.a.` : '-'}
              </Typography>
            </Box>
          </Box>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default ActiuCardGlobal;
